import script from "./FunnelCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FunnelCard.vue?vue&type=script&setup=true&lang=ts"

import "./FunnelCard.vue?vue&type=style&index=0&id=008d38a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008d38a8"]])

export default __exports__